import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { RoleBadge } from "@/components/shared";
import { Loader2, ChevronLeft, ChevronRight } from "lucide-react";

const ACTION_COLORS = {
  login: "text-slate", logout: "text-slate",
  create_member: "text-positive", update_member: "text-ink",
  change_status: "text-brick", invite_member: "text-brass",
  import_dry_run: "text-slate", import_commit: "text-positive",
  export_excel: "text-ink", export_pdf: "text-ink",
};

export default function AuditLog() {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/audit", { params: { page, page_size: 50 } }).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [page]);

  const totalPages = data ? Math.max(1, Math.ceil(data.total / data.page_size)) : 1;

  return (
    <Layout title="Log Audit / Audit Log" subtitle="Immutable trail — who, what, when (Super Admin only)">
      <div className="bg-white border border-hairline rounded-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead><tr className="bg-paper border-y border-ink/20">
              <th className="text-left text-xs uppercase tracking-wider text-slate font-medium py-3 px-4">Masa / Time</th>
              <th className="text-left text-xs uppercase tracking-wider text-slate font-medium py-3 px-4">Actor</th>
              <th className="text-left text-xs uppercase tracking-wider text-slate font-medium py-3 px-4">Action</th>
              <th className="text-left text-xs uppercase tracking-wider text-slate font-medium py-3 px-4">Entity</th>
              <th className="text-left text-xs uppercase tracking-wider text-slate font-medium py-3 px-4">Details</th>
            </tr></thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={5} className="py-16 text-center text-slate"><Loader2 className="animate-spin inline mr-2" size={18} />Loading…</td></tr>
              ) : data.logs.length === 0 ? (
                <tr><td colSpan={5} className="py-16 text-center text-slate">Tiada log / No entries.</td></tr>
              ) : data.logs.map((l) => (
                <tr key={l.id} className="ledger-row" data-testid={`audit-row-${l.id}`}>
                  <td className="py-2.5 px-4 font-mono text-xs text-slate whitespace-nowrap">{(l.at || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="py-2.5 px-4 text-sm">
                    <div className="text-ink">{l.actor_email}</div>
                    <div className="mt-0.5"><RoleBadge role={l.actor_role} /></div>
                  </td>
                  <td className={`py-2.5 px-4 text-sm font-medium ${ACTION_COLORS[l.action] || "text-ink"}`}>{l.action}</td>
                  <td className="py-2.5 px-4 text-xs font-mono text-slate">{l.entity_type}{l.entity_id ? `:${String(l.entity_id).slice(0, 8)}` : ""}</td>
                  <td className="py-2.5 px-4 text-xs text-slate max-w-xs truncate">{JSON.stringify(l.details)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {data && data.total > data.page_size && (
          <div className="flex items-center justify-between px-4 py-3 border-t border-hairline">
            <span className="text-xs text-slate">Halaman {page} / {totalPages} · {data.total} entries</span>
            <div className="flex gap-2">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)} className="p-1.5 border border-hairline rounded-sm disabled:opacity-40 hover:bg-paper"><ChevronLeft size={16} /></button>
              <button disabled={page >= totalPages} onClick={() => setPage(page + 1)} className="p-1.5 border border-hairline rounded-sm disabled:opacity-40 hover:bg-paper"><ChevronRight size={16} /></button>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
